const ruleDashboard = 'dashboard';
const login = 'login';
const error = 'error';
const rulePlans = 'rule_plan';
const ruleGroups = 'rule_group';
const rules = 'rules';
const program = 'program';
const frequency = 'frequency';
const workflow = 'workflow';
const ruleManagement = 'rule';
const incentiveProgram = 'incentive_program';
const unifiedSourceMaster = 'unified_source_master';
const unifiedSourceList = 'unified_source_list';

const profile = 'profile';
// const targetSettingConfig = 'target_config';
const targetConfiguration = 'target_configuration';
const userDetails = 'user_details';
const holiday = 'holiday';
const targetHierarchy = 'target_hierarchy';
const categoryManagement = 'category_management';
const category = 'categories';
const uploadProductImage = 'custom_images';
const contest = 'contest';
const QueryConfig = 'QueryConfig';
const QueryConfigmapping = 'program-query';
const query = 'program-queries';
const QueryConfigUpdate = 'update-program-query';
const bulkRule = 'bulk_rule';
const bulkRuleUpload = 'bulk_rule_upload';
const bulkRuleDownload = 'bulk_rule_download';
const RuleWorkflow = 'rule_workflow';
const hook = 'hook';
const hookEvent = 'hook_event';
const hookRegistration = 'hook_registration';
const hookInstance = 'hook_instance';
const hookVariable = 'hook_variable';
const hookCustomScreens = 'hook_custom_screens';

const resourceName = {
  ruleDashboard,
  login,
  error,
  rulePlans,
  ruleGroups,
  rules,
  program,
  frequency,
  workflow,
  ruleManagement,
  incentiveProgram,
  unifiedSourceMaster,
  unifiedSourceList,
  profile,
  targetConfiguration,
  userDetails,
  holiday,
  targetHierarchy,
  categoryManagement,
  category,
  uploadProductImage,
  contest,
  QueryConfig,
  QueryConfigmapping,
  query,
  QueryConfigUpdate,
  bulkRuleUpload,
  RuleWorkflow,
  bulkRule,
  bulkRuleDownload,
  hook,
  hookEvent,
  hookRegistration,
  hookInstance,
  hookVariable,
  hookCustomScreens,
};

export default resourceName;
